import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>服务集群</h3>
            <div className="service-cluster">
              <div className="cluster-item">
                <h4>星晟</h4>
                <p>工程领域专家</p>
                <a href="http://www.xingsnb.cn" target="_blank" rel="noopener noreferrer">了解更多 →</a>
              </div>
              <div className="cluster-item">
                <h4>昇晟</h4>
                <p>AI服务解决专家</p>
                <a href="http://www.sunsnb.com" target="_blank" rel="noopener noreferrer">了解更多 →</a>
              </div>
              <div className="cluster-item">
                <h4>识道咨询</h4>
                <p>专业财税服务专家</p>
                <a href="http://sdzx.xingsnb.cn" target="_blank" rel="noopener noreferrer">了解更多 →</a>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h3>核心服务</h3>
            <ul>
              <li><Link to="/services#investment">投资估算咨询</Link></li>
              <li><Link to="/services#design">设计概算咨询</Link></li>
              <li><Link to="/services#budget">工程预算咨询</Link></li>
              <li><Link to="/services#settlement">工程结算咨询</Link></li>
              <li><Link to="/services#other">工程其他费咨询</Link></li>
              <li><Link to="/services#final">项目决算咨询</Link></li>
              <li><Link to="/services#tendering">招投标代理服务</Link></li>
              <li><Link to="/services#procurement">采购业务代理</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>快速导航</h3>
            <ul>
              <li><Link to="/">首页</Link></li>
              <li><Link to="/projects">成功案例</Link></li>
              <li><Link to="/platform">数智平台</Link></li>
              <li><Link to="/notices">通知公告</Link></li>
              <li><Link to="/about">关于我们</Link></li>
              <li><Link to="/careers">加入我们</Link></li>
              <li><Link to="/contact">联系我们</Link></li>
              <li><Link to="/faq">常见问题</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>联系方式</h3>
            <ul className="contact-info">
              <li>
                <span className="icon">📍</span>
                <span>地址：宁波市高新区创苑路750号软件园D座8F</span>
              </li>
              <li>
                <span className="icon">📞</span>
                <a type='tel' href="tel:13957808808">电话：139-5780-8808</a>
              </li>
              <li>
                <span className="icon">📧</span>
                <span>邮箱：shidao@yuezhong.com</span>
              </li>
              <li>
                <span className="icon">🕐</span>
                <span>工作时间：周一至周五 9:00-18:00</span>
              </li>
            </ul>
          </div>

          {/* <div className="footer-section">
            <h3>关注我们</h3>
            <div className="social-links">
              <a href="#" className="social-icon">微信</a>
              <a href="#" className="social-icon">微博</a>
            </div>
            <div className="qr-code">
              <p>扫码关注</p>
              <div className="qr-placeholder">二维码占位</div>
            </div>
          </div> */}
        </div>

        <div className="footer-bottom">
          <p>&copy;识道造价 版权所有</p>
          <p>
            <a href="#">备案号：浙ICP备2023023521号-1</a> |
            <a href="#">隐私政策</a> |
            <a href="#">使用条款</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

